<template>
    <div class="container-fluid">
          <div>
            <b-embed
               type="iframe"
               :src="('/Nextspin_Company_Profile.pdf')"
               allowfullscreen
            ></b-embed>
            <!-- <a href="#" :data-title="item.name" :data-url="`/doc-viewer/files/demo.pdf`" @click="$root.$emit('bv::show::modal', 'viewer-modal', $event.target)" v-b-modal.viewer-modal>
                <b-button pill variant="outline-orange" class="mt-2 mr-1 text-black float-right" >Game Overview</b-button>

            </a> -->
            </div>
      </div>
</template>
<script>
export default {
    name:'CompanyProfile',

    data() {
        return {
            language: undefined,
        }
    },

    async mounted() {
        let user = JSON.parse(localStorage.getItem("user"));

        if (user.language === 'en_US' || user.language === undefined) {
            this.language = 'en'  
        } 
        
        if (user.language === 'zh_CN') {
            this.language = 'cn'    
        } 
        
    },
}
</script>